import { createMuiTheme, colors } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: colors.green[700]
    },
    secondary: {
      main: colors.green[700]
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
});

export default theme;
